import React from 'react';
import {COPY_STRINGS} from '../../constants/translatedCopy';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";

export class RetryNetworkReconnectModal extends React.Component {
  countdownInterval;

  constructor (props) {
    super(props);

    this.state = {
      countingNum: undefined,
      showTryAgain: false,
    }

    this.retryPressed = this.retryPressed.bind(this);
  }

  componentDidMount() {
    let speechProps = {
      textToSpeak: COPY_STRINGS.retry_pause_network_speech,
      onEnd: () => {
        this.setState({
          countingNum: 1,
        });
        this.countdownInterval = setInterval(() => {
          if (this.state.countingNum < 3) {
            this.setState({
              countingNum: this.state.countingNum + 1,
            });
          } else {
            clearInterval(this.countdownInterval);
            this.countdownInterval = undefined;
            this.setState({
              showTryAgain: true,
              countingNum: undefined,
            });
          }
        }, 1000);
      }
    };

    this.props.speech.speak(speechProps);
  }

  componentWillUnmount() {
    if (this.countdownInterval) {
      clearTimeout(this.countdownInterval);
    }
  }

  retryPressed() {
    this.props.continue();
  }

  render() {
    return (
      <div className="restartModal">
        <div className="alert">{COPY_STRINGS.retry_pause_network_title}</div>
        {this.state.countingNum && <div className="explanation labelFontOverride" style={{ marginTop: '4vh', fontSize: '6vh' }}>
          {this.state.countingNum}
        </div>}
        {this.state.showTryAgain &&
          <button className="restartButton primaryButton" style={{ marginTop: '4vh' }} onClick={this.retryPressed} type="button">{COPY_STRINGS.retry_pause_network_button}</button>
        }
      </div>
    );
  }
}
